// Shared pill/swatch renderer used by both assets/addon-upsell.js and
// assets/mount-finder.js, so every option picker on the site (product-page
// add-ons and the Mount Finder's main product) renders identical markup —
// one place defines what a pill or a color swatch looks like. Must load
// before either of those scripts.
window.StrikerVariantPicker = (function () {
  const COLOR_SWATCHES = {
    black: '#000000',
    'army green': '#85a177',
    white: '#ffffff',
    orange: '#ff8a00',
    'cool gray': '#8b979c',
    'cool grey': '#8b979c',
    gray: '#8b979c',
    grey: '#8b979c',
  };

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function colorSwatchHex(name) {
    const key = (name || '').trim().toLowerCase();
    return COLOR_SWATCHES[key] || '#cccccc';
  }

  // Renders one option group as a <fieldset> of radio pills, or — for a
  // "Color" option — color-dot swatches. Selection is tracked purely by
  // index (data-option-index / data-value-index) against the caller's own
  // in-memory values array, never by reading the option string back out of
  // an HTML attribute; option values can contain characters like `"` that
  // are unsafe to round-trip through attributes.
  //
  // group: { name, groupIndex, values: string[] }
  // opts:
  //   idPrefix: string — unique per-picker prefix for input ids/names
  //   isChecked(value, valueIndex): bool
  //   isAvailable(value, valueIndex): bool
  function renderOptionGroup(group, opts) {
    const { name, groupIndex, values } = group;
    // Substring match, not exact — real option names are often "Corner/
    // Handle Color" or "AirTag Holder Color", not the bare word "Color".
    const isColor = /color/i.test(name.trim());
    const labelMarkup =
      !isColor && name.trim() !== '' ? `<span class="addon-upsell__option-label">${escapeHtml(name)}</span>` : '';
    // Always give the group a programmatic name for assistive tech, even when
    // the visible text label is hidden (e.g. the add-on module hides it via
    // CSS because the pills are self-explanatory). Screen readers still
    // announce "Length", "Pack Size", etc.
    const ariaLabelAttr = name.trim() !== '' ? ` aria-label="${escapeHtml(name)}"` : '';

    const inputsMarkup = values
      .map((value, valueIndex) => {
        const inputId = `${opts.idPrefix}-${groupIndex}-${valueIndex}`;
        const checked = opts.isChecked(value, valueIndex);
        const available = opts.isAvailable(value, valueIndex);
        const isDisabled = !available;

        if (isColor) {
          return `
            <input
              type="radio"
              id="${inputId}"
              name="${opts.idPrefix}-${groupIndex}"
              data-option-index="${groupIndex}"
              data-value-index="${valueIndex}"
              class="swatch-input__input"
              ${checked ? 'checked' : ''}
              ${isDisabled ? 'disabled' : ''}
            >
            <label for="${inputId}" title="${escapeHtml(value)}" class="swatch-input__label">
              <span class="swatch" style="--swatch--background:${colorSwatchHex(value)};"></span>
            </label>
          `;
        }

        return `
          <input
            type="radio"
            id="${inputId}"
            name="${opts.idPrefix}-${groupIndex}"
            data-option-index="${groupIndex}"
            data-value-index="${valueIndex}"
            ${checked ? 'checked' : ''}
            ${isDisabled ? 'disabled' : ''}
          >
          <label for="${inputId}">${escapeHtml(value)}</label>
        `;
      })
      .join('');

    const variantClass = isColor ? 'product-form__input--swatch' : 'product-form__input--pill';
    return `
      <fieldset class="js addon-upsell__group product-form__input ${variantClass}"${ariaLabelAttr}>
        ${labelMarkup}
        ${inputsMarkup}
      </fieldset>
    `;
  }

  return { COLOR_SWATCHES, escapeHtml, colorSwatchHex, renderOptionGroup };
})();
